<template>
  <div class="w-12 h-12 flex-shrink-0">
    <SkeletonImage
      class="object-contain w-full h-full"
      variant="light"
      :src="imageSrc"
      @error="onError"
    />
  </div>
</template>

<script>
import { UrlPath } from "num-client";
import SkeletonImage from "@/components/SkeletonImage";

import numQuery from "@/mixins/numQuery";

import { chooseImage } from "@/utils/utils";

export default {
  name: "NumImage",
  mixins: [numQuery],
  components: {
    SkeletonImage,
  },
  props: {
    controller: String,
    mainLoaded: Boolean,
    result: Object,
    src: String,
    url: String,
  },
  data() {
    return {
      errored: false,
      moduleId: 3,
    };
  },
  computed: {
    dnsImage() {
      return chooseImage(this.json?.images);
    },
    imageSrc() {
      if (this.dnsImage && !this.errored) {
        return this.dnsImage;
      } else if ((this.querying || !this.mainLoaded) && !this.errored) {
        return null;
      } else if (this.src && !this.errored) {
        return this.src;
      } else {
        if (this.controller) {
          return `/img/fallback/social.png`;
        } else if (this.result?.method_type === "link") {
          return `/img/fallback/link.png`;
        } else {
          return `/img/fallback/office.png`;
        }
      }
    },
    persistRecord() {
      return this.controller;
    },
  },
  watch: {
    json(newVal) {
      this.$emit("json-changed", newVal);
    },
    url: {
      handler(newVal) {
        if (newVal) this.getImage(newVal);
        else this.querying = false;
      },
      immediate: true,
    },
  },
  methods: {
    async getImage(url) {
      await this.getNumResult(url);
      const { path } = this.numUri;
      // if we don't have an image, and this isn't the root, get the root image
      if (!this.dnsImage && path.s !== "/") {
        const rootNumUri = this.numUri.withPath(new UrlPath("/"));
        const rootNumUriString = rootNumUri.toString();
        this.getNumResult(rootNumUriString);
      }
    },
    onError() {
      this.errored = true;
    },
  },
};
</script>
